import { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form'
import { useSelector } from 'react-redux'

import Box from '~/core/Box'
import { getUserIdentity } from '~/redux-modules/identity'
import PersonalInformation from '../PersonalInformation'
import AccountSettings from '../AccountSettings'
import PaymentMethods from '../PaymentMethods'
import { DeleteAccountButton } from '../PersonalInformation/components'
import styles from '../styles.css'

interface MainProfileContentProps {
    businessAccountName: string
}

const MainProfileContent: FC<MainProfileContentProps> = ({
    businessAccountName,
}) => {
    const location = useLocation()
    const [popConfirmation, setPopConfirmation] = useState<string | null>(null)
    const [selectedField, setSelectedField] = useState<string | null>(null)
    const [nextSelectedField, setNextSelectedField] = useState<string | null>(
        null,
    )
    const [currentForm, setCurrentForm] = useState<WrappedFormUtils | null>(
        null,
    )
    const identity = useSelector(getUserIdentity)
    const queryString = location.search

    const handleSelectEdit = (field: string | null) => {
        if (!field) {
            if (currentForm) {
                currentForm.resetFields()
            }
            setCurrentForm(null)
            setSelectedField(null)
            if (nextSelectedField) {
                setSelectedField(nextSelectedField)
                setNextSelectedField(null)
            }
            return setPopConfirmation(null)
        }
        if (selectedField && currentForm?.isFieldsTouched()) {
            setNextSelectedField(field)
            return setPopConfirmation(selectedField)
        } else {
            setCurrentForm(null)
            setSelectedField(field)
        }
    }

    return (
        <>
            <PersonalInformation
                identity={identity}
                selectedField={selectedField}
                handleSelectEdit={handleSelectEdit}
                popConfirmation={popConfirmation}
                setCurrentForm={setCurrentForm}
            />
            <AccountSettings
                identity={identity}
                selectedField={selectedField}
                handleSelectEdit={handleSelectEdit}
                popConfirmation={popConfirmation}
                setCurrentForm={setCurrentForm}
                queryString={queryString}
                businessAccountName={businessAccountName}
            />
            <PaymentMethods
                identity={identity}
                selectedField={selectedField}
                handleSelectEdit={handleSelectEdit}
                popConfirmation={popConfirmation}
                setCurrentForm={setCurrentForm}
            />
            <Box className={`${styles.section} ${styles.mobileShow}`}>
                <DeleteAccountButton
                    identity={identity}
                    className={styles.mobileShow}
                />
            </Box>
        </>
    )
}

export default MainProfileContent
